<template>
  <el-dialog
    append-to-body
    :title="$t('software.addSoftwareDictionary')"
    :visible="true"
    @close="handleCloseDialog"
    :closeOnClickModal="false"
    width="540px"
  >
    <el-form labelWidth="110px" ref="fileForm" :model="addSoftDicForm" :rules="rules">
      <el-form-item :label="$t('software.softwareName')" prop="name" verify>
        <el-input v-model="addSoftDicForm.name"></el-input>
      </el-form-item>
      <el-form-item :label="$t('software.matchType')" prop="matchType" verify>
        <el-select v-model="addSoftDicForm.matchType">
          <el-option
            v-for="item in Object.values(MATCH_TYPE).filter(item => {
              return item === MATCH_TYPE.LIKE
            })"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCloseDialog">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{ $t('confirm') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { Dialog, Form, FormItem, Input, Select, Button, Option } from 'element-ui'

import { addGlobalSoftwareDict } from '@/api/terminal'

import { MATCH_TYPE } from '@/utils/enum'

export default {
  name: 'AddSoftwareDialog',
  components: {
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Select.name]: Select,
    [Button.name]: Button,
    [Option.name]: Option
  },
  props: {
    id: {
      type: [Number, String],
      default() {
        return ''
      }
    },
    categoryId: {
      type: [Number, String],
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      MATCH_TYPE,
      dialogVisible: true,
      addSoftDicForm: {
        name: '',
        matchType: MATCH_TYPE.LIKE
      },
      rules: {
        name: [
          [
            { required: true, message: this.$t('software.name_not_empty'), trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (value.length < 2) {
                  callback(new Error(this.$t('software.name_length_limit')))
                } else {
                  callback()
                }
              }
            }
          ]
        ],
        matchType: [[{ required: true, message: this.$t('software.type_not_empty') }]]
      }
    }
  },
  created() {},
  methods: {
    handleConfirm() {
      this.$refs.fileForm.validate(valid => {
        if (valid) {
          addGlobalSoftwareDict(this.addSoftDicForm).then(() => {
            this.$emit('success')
          })
        }
      })
    },
    handleCloseDialog() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss">
.el-dialog .el-form {
  margin-bottom: 0px;
}
</style>
